import { Button, Icon, Label, List } from '@mairistem/composants';
import _ from 'lodash';
import type React from 'react';
import { APPLICATIONS_SOURCES } from '@/constants';
import type { LogicielFacturier, ProduitJvsType } from '@/types';
import { getRegieCodeFromJvs } from '@/utils';
import UuidInput from './UuidInput';

interface ApplicationsSourcesListItemProps {
  produit: ProduitJvsType & { logicielFacturier: LogicielFacturier };
  loading: boolean;
  onUuidGenerate: () => void;
  onPlugClick: () => void;
  onCopyToClipboard: () => void;
}

const ApplicationsSourcesListItem: React.FC<ApplicationsSourcesListItemProps> = ({
  produit,
  loading,
  onUuidGenerate,
  onPlugClick,
  onCopyToClipboard,
}) => {
  const { identifiant, code, logicielFacturier } = produit;
  const codeRegie = getRegieCodeFromJvs(code);

  return (
    <List.Item
      key={`produits-${identifiant}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        height: 60,
      }}
    >
      <List.Content style={{ flex: 1 }}>
        <List.Header style={{ display: 'flex', alignItems: 'center' }}>
          <Label
            circular
            color={logicielFacturier?.actif ? 'green' : 'red'}
            empty
            size="big"
            style={{ marginRight: '0.5em' }}
          />
          {`${APPLICATIONS_SOURCES.APPLICATIONS_REGIE_LISTE[codeRegie]} (${codeRegie})`}
        </List.Header>
      </List.Content>
      {!_.isEmpty(logicielFacturier?.cleLiaison) && (
        <List.Content style={{ width: 500 }}>
          <List.Header>
            <UuidInput
              value={logicielFacturier.cleLiaison}
              plugged={logicielFacturier.actif}
              onCopyClick={onCopyToClipboard}
              onPlug={onPlugClick}
              onUnplug={onPlugClick}
              loading={loading}
            />
          </List.Header>
        </List.Content>
      )}
      {_.isEmpty(logicielFacturier?.cleLiaison) && (
        <Button
          data-testid="generate-uuid-button"
          positive
          loading={loading}
          disabled={loading}
          onClick={onUuidGenerate}
          style={{ width: 500 }}
        >
          <Icon name="refresh" />
          Générer un identifiant de liaison unique
        </Button>
      )}
    </List.Item>
  );
};

export default ApplicationsSourcesListItem;
